var ST;
(function (ST) {
    let activeGridId = null;
    function clearActiveGrid() {
        activeGridId = null;
    }
    ST.clearActiveGrid = clearActiveGrid;
    function hasActiveGrid() {
        return activeGridId !== null;
    }
    ST.hasActiveGrid = hasActiveGrid;
    class Grid {
        constructor(_dotNetObj, _gridId) {
            this.resizeHandleRefs = [];
            this.dotNetObject = null;
            this.gridId = null;
            this.gridElement = null;
            this.frameElement = null;
            this.heightHandle = null;
            this.autoHeight = false;
            this.autoHeightMin = 180;
            this.autoHeightBottomMargin = 12;
            this.isHeightResizing = false;
            this.manualHeight = false;
            this.heightClientYStartPoint = -1;
            this.heightStart = -1;
            this.dotNetObject = _dotNetObj;
            this.gridId = _gridId;
            this.gridElement = document.getElementById(this.gridId);
            this.frameElement = this.gridElement.parentElement;
            this.keyUpHandlerRef = (e) => this.keyUpHandler(e);
            this.keyDownHandlerRef = (e) => this.keyDownHandler(e);
            this.copyHandlerRef = (e) => this.copyHandler(e);
            this.pasteHandlerRef = (e) => this.pasteHandler(e);
            this.activeHandlerRef = () => this.setActive();
            this.gridElement.addEventListener('keyup', this.keyUpHandlerRef);
            this.gridElement.addEventListener('keydown', this.keyDownHandlerRef);
            this.gridElement.addEventListener('mousedown', this.activeHandlerRef);
            this.gridElement.addEventListener('focusin', this.activeHandlerRef);
            document.addEventListener('copy', this.copyHandlerRef);
            document.addEventListener('paste', this.pasteHandlerRef);
        }
        setActive() {
            activeGridId = this.gridId;
        }
        isActive() {
            return activeGridId === this.gridId;
        }
        keyUpHandler(e) {
            this.setActive();
            if (e.key == 'Tab' || e.key == 'Enter') {
                console.log("input value bef blur: " + e.target['value']);
                let blurEvent = new Event('change');
                e.target.dispatchEvent(blurEvent);
            }
            var navegacion = [8, 9, 13, 27, 37, 38, 39, 40, 46];
            if (navegacion.indexOf(e.which) >= 0) {
                e.preventDefault();
            }
            this.dotNetObject.invokeMethodAsync('OnKeyUp', e.which);
        }
        keyDownHandler(e) {
            if (Utils.isEditableElement(e.target)) {
                return;
            }
            if ([37, 38, 39, 40].indexOf(e.which) >= 0) {
                e.preventDefault();
            }
        }
        copyHandler(e) {
            if (Utils.isEditableElement(e.target) || !this.isActive()) {
                return;
            }
            console.log("On copy...");
            this.dotNetObject.invokeMethodAsync('OnCopy');
        }
        pasteHandler(e) {
            if (Utils.isEditableElement(e.target) || !this.isActive()) {
                return;
            }
            console.log("On paste...");
            navigator.clipboard.readText().then((text) => {
                this.dotNetObject.invokeMethodAsync('OnPaste', text);
            });
        }
        focusAndSelect(_id, _initialValue) {
            let element = document.getElementById(_id);
            if (element) {
                element.focus();
                if (_initialValue) {
                    element.value = _initialValue;
                }
                else if (typeof element.select === 'function') {
                    element.select();
                }
            }
        }
        setClipboardRows(_rows, _head) {
            let table = document.createElement('table');
            if (_head && _head.length > 0) {
                var thead = document.createElement('thead');
                for (var i = 0; i < _head.length; i++) {
                    var th = document.createElement('th');
                    th.style.fontWeight = 'bold';
                    th.style.backgroundColor = '#CCCCCC';
                    th.innerText = _head[i].title;
                    thead.appendChild(th);
                }
                table.appendChild(thead);
            }
            if (_rows && _rows.length > 0) {
                let tbody = document.createElement('tbody');
                let tbodyFragment = document.createDocumentFragment();
                for (let i = 0; i < _rows.length; i++) {
                    let tr = document.createElement('tr');
                    for (let j = 0; j < _rows[i].cells.length; j++) {
                        let td = document.createElement('td');
                        this.formatCellAsText(td, _rows[i].cells[j].isText);
                        td.innerText = _rows[i].cells[j].value;
                        tr.appendChild(td);
                    }
                    tbodyFragment.append(tr);
                }
                tbody.append(tbodyFragment);
                table.appendChild(tbody);
            }
            let html = table.outerHTML;
            let blob = new Blob([html], { type: "text/html" });
            navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
        }
        setClipboardValue(_value, _isText) {
            if (_isText) {
                this.setClipboardRows([{ cells: [{ value: _value, isText: true }] }], null);
                return;
            }
            navigator.clipboard.writeText(_value);
        }
        formatCellAsText(_cell, _isText) {
            if (!_isText) {
                return;
            }
            _cell.setAttribute('style', 'mso-number-format:"\\@";');
            _cell.setAttribute('x:str', '');
        }
        configureColumnResize(enabled) {
            this.clearColumnResize();
            if (!enabled || !this.gridElement) {
                return;
            }
            let handles = this.gridElement.querySelectorAll('.st-grid-resizer[data-column-id]');
            handles.forEach(handle => {
                let handler = (e) => this.startColumnResize(e, handle.dataset.columnId || '');
                handle.addEventListener('mousedown', handler);
                this.resizeHandleRefs.push({ element: handle, handler: handler });
            });
        }
        clearColumnResize() {
            this.resizeHandleRefs.forEach(item => item.element.removeEventListener('mousedown', item.handler));
            this.resizeHandleRefs = [];
            if (this.activeMouseMoveRef) {
                document.removeEventListener('mousemove', this.activeMouseMoveRef);
                this.activeMouseMoveRef = null;
            }
            if (this.activeMouseUpRef) {
                document.removeEventListener('mouseup', this.activeMouseUpRef);
                this.activeMouseUpRef = null;
            }
        }
        startColumnResize(e, columnId) {
            if (!columnId) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            let stopClick = (clickEvent) => {
                clickEvent.preventDefault();
                clickEvent.stopPropagation();
            };
            let header = this.gridElement.querySelector(`th[data-column-id="${columnId}"]`);
            let table = this.gridElement.querySelector('table');
            if (!header || !table) {
                return;
            }
            let startX = e.clientX;
            let startWidth = header.getBoundingClientRect().width;
            this.activeMouseMoveRef = (moveEvent) => {
                let newWidth = Math.max(30, Math.round(startWidth + (moveEvent.clientX - startX)));
                this.applyColumnWidth(columnId, newWidth);
            };
            this.activeMouseUpRef = () => {
                let finalWidth = Math.max(30, Math.round(header.getBoundingClientRect().width));
                document.removeEventListener('mousemove', this.activeMouseMoveRef);
                document.removeEventListener('mouseup', this.activeMouseUpRef);
                this.activeMouseMoveRef = null;
                this.activeMouseUpRef = null;
                window.setTimeout(() => {
                    this.gridElement.removeEventListener('click', stopClick, true);
                }, 0);
                this.dotNetObject.invokeMethodAsync('OnColumnResized', columnId, finalWidth);
            };
            this.gridElement.addEventListener('click', stopClick, true);
            document.addEventListener('mousemove', this.activeMouseMoveRef);
            document.addEventListener('mouseup', this.activeMouseUpRef);
        }
        scrollToCell(_dataRowIndex, _visibleRowIndex, _columnId) {
            let scrollCellIntoView = () => {
                let cells = this.gridElement.querySelectorAll('td[data-row-index][data-column-id]');
                let cell = Array.from(cells).find(element => element.dataset.rowIndex == _dataRowIndex.toString() &&
                    element.dataset.columnId == _columnId);
                if (!cell) {
                    return false;
                }
                let containerRect = this.gridElement.getBoundingClientRect();
                let cellRect = cell.getBoundingClientRect();
                if (cellRect.top < containerRect.top) {
                    this.gridElement.scrollTop -= containerRect.top - cellRect.top;
                }
                else if (cellRect.bottom > containerRect.bottom) {
                    this.gridElement.scrollTop += cellRect.bottom - containerRect.bottom;
                }
                if (cellRect.left < containerRect.left) {
                    this.gridElement.scrollLeft -= containerRect.left - cellRect.left;
                }
                else if (cellRect.right > containerRect.right) {
                    this.gridElement.scrollLeft += cellRect.right - containerRect.right;
                }
                return true;
            };
            if (scrollCellIntoView()) {
                return;
            }
            let renderedRow = this.gridElement.querySelector('tbody tr');
            let rowHeight = (renderedRow === null || renderedRow === void 0 ? void 0 : renderedRow.getBoundingClientRect().height) || 27;
            this.gridElement.scrollTop = _visibleRowIndex * rowHeight;
            requestAnimationFrame(() => requestAnimationFrame(scrollCellIntoView));
        }
        configureAutoHeight(enabled, minHeight = 180, bottomMargin = 12) {
            this.clearAutoHeight();
            this.autoHeight = enabled;
            this.autoHeightMin = minHeight;
            this.autoHeightBottomMargin = bottomMargin;
            if (!enabled || !this.frameElement) {
                return;
            }
            this.heightHandle = document.getElementById('h_' + this.gridId);
            if (!this.heightHandle) {
                return;
            }
            this.manualHeight = this.frameElement.getAttribute('data-auto-height-disabled') == 'true';
            let initialHeight = parseFloat(this.frameElement.getAttribute('data-initial-height'));
            if (!Number.isFinite(initialHeight)) {
                initialHeight = Math.round(this.frameElement.getBoundingClientRect().height);
            }
            this.frameElement.style.height = initialHeight + 'px';
            this.heightMouseDownRef = (e) => this.startHeightResize(e);
            this.heightMouseMoveRef = (e) => this.moveHeightResize(e);
            this.heightMouseUpRef = (e) => this.endHeightResize(e);
            this.heightResizeRef = () => this.setAutoHeight();
            this.heightHandle.addEventListener('mousedown', this.heightMouseDownRef);
            document.addEventListener('mousemove', this.heightMouseMoveRef);
            document.addEventListener('mouseup', this.heightMouseUpRef);
            window.addEventListener('resize', this.heightResizeRef);
            if (!this.manualHeight) {
                requestAnimationFrame(() => this.setAutoHeight());
            }
        }
        clearAutoHeight() {
            if (this.heightHandle && this.heightMouseDownRef) {
                this.heightHandle.removeEventListener('mousedown', this.heightMouseDownRef);
            }
            if (this.heightMouseMoveRef) {
                document.removeEventListener('mousemove', this.heightMouseMoveRef);
            }
            if (this.heightMouseUpRef) {
                document.removeEventListener('mouseup', this.heightMouseUpRef);
            }
            if (this.heightResizeRef) {
                window.removeEventListener('resize', this.heightResizeRef);
            }
            this.heightHandle = null;
            this.heightMouseDownRef = null;
            this.heightMouseMoveRef = null;
            this.heightMouseUpRef = null;
            this.heightResizeRef = null;
        }
        setAutoHeight() {
            if (!this.autoHeight || this.manualHeight || !this.frameElement) {
                return;
            }
            let footer = document.querySelector('.footer');
            let footerHeight = footer && window.getComputedStyle(footer).position == 'fixed'
                ? footer.getBoundingClientRect().height
                : 0;
            let bottomLimit = window.innerHeight - footerHeight - this.autoHeightBottomMargin;
            let gridTop = this.frameElement.getBoundingClientRect().top;
            let followingHeight = this.getFollowingControlsHeight();
            let finalHeight = Math.max(this.autoHeightMin, bottomLimit - gridTop - followingHeight);
            this.setHeight(finalHeight, this.autoHeightMin);
        }
        getFollowingControlsHeight() {
            let total = 0;
            let next = this.frameElement.nextElementSibling;
            while (next) {
                if (this.shouldIncludeFollowingControl(next)) {
                    total += next.getBoundingClientRect().height;
                }
                next = next.nextElementSibling;
            }
            return total;
        }
        shouldIncludeFollowingControl(element) {
            if (element.classList.contains('grid-context-menu') ||
                element.classList.contains('grid-context-menu-closer')) {
                return false;
            }
            let position = window.getComputedStyle(element).position;
            return position != 'fixed' && position != 'absolute';
        }
        setHeight(height, minHeight = 0) {
            let finalHeight = minHeight > 0 ? Math.max(minHeight, height) : height;
            this.frameElement.style.height = finalHeight.toFixed(0) + 'px';
            this.frameElement.setAttribute('data-initial-height', finalHeight.toFixed(0));
        }
        startHeightResize(e) {
            e.stopPropagation();
            if (this.isHeightResizing) {
                return;
            }
            this.isHeightResizing = true;
            this.manualHeight = true;
            this.frameElement.setAttribute('data-auto-height-disabled', 'true');
            this.heightClientYStartPoint = e.clientY;
            this.heightStart = parseFloat(this.frameElement.style.height.replace('px', ''));
            if (!Number.isFinite(this.heightStart)) {
                this.heightStart = Math.round(this.frameElement.getBoundingClientRect().height);
            }
            this.heightHandle.classList.add('bg-primary');
            e.preventDefault();
        }
        moveHeightResize(e) {
            e.stopPropagation();
            if (!this.isHeightResizing) {
                return;
            }
            let dy = e.clientY - this.heightClientYStartPoint;
            this.setHeight(this.heightStart + dy);
            e.preventDefault();
        }
        endHeightResize(e) {
            e.stopPropagation();
            if (!this.isHeightResizing) {
                return;
            }
            this.isHeightResizing = false;
            this.heightHandle.classList.remove('bg-primary');
            e.preventDefault();
        }
        getTableColumnsWidth() {
            let totalWidth = 0;
            let headers = this.gridElement.querySelectorAll('thead th');
            headers.forEach(header => {
                if (header.classList.contains('grid-filler-column')) {
                    return;
                }
                let width = parseInt(header.style.width.replace('px', ''));
                if (!Number.isFinite(width)) {
                    width = Math.round(header.getBoundingClientRect().width);
                }
                totalWidth += width;
            });
            return Math.max(30, totalWidth);
        }
        applyColumnWidth(columnId, width) {
            let header = this.gridElement.querySelector(`th[data-column-id="${columnId}"]`);
            if (header) {
                header.style.width = `${width}px`;
                header.style.minWidth = `${width}px`;
                header.style.maxWidth = `${width}px`;
            }
            let cells = this.gridElement.querySelectorAll(`td[data-column-id="${columnId}"]`);
            cells.forEach(cell => {
                cell.style.width = `${width}px`;
                cell.style.minWidth = `${width}px`;
                cell.style.maxWidth = `${width}px`;
            });
            let table = this.gridElement.querySelector('table');
            if (table) {
                let tableWidth = this.getTableColumnsWidth();
                table.style.width = '100%';
                table.style.minWidth = `${tableWidth}px`;
                table.style.maxWidth = '';
            }
        }
        dispose() {
            console.log("Removing event listeners");
            this.gridElement.removeEventListener('keyup', this.keyUpHandlerRef);
            this.gridElement.removeEventListener('keydown', this.keyDownHandlerRef);
            this.gridElement.removeEventListener('mousedown', this.activeHandlerRef);
            this.gridElement.removeEventListener('focusin', this.activeHandlerRef);
            document.removeEventListener('copy', this.copyHandlerRef);
            document.removeEventListener('paste', this.pasteHandlerRef);
            this.clearColumnResize();
            this.clearAutoHeight();
            console.log("Event listeners removed");
        }
    }
    function crearGrid(_dotNetObj, _gridId) {
        return new Grid(_dotNetObj, _gridId);
    }
    ST.crearGrid = crearGrid;
})(ST || (ST = {}));
